export default "__VITE_ASSET__Babq9XER__"